import type { Plan, UpgradeRequiredPayload } from '@deepguide-ai/types'
import {
  UPGRADE_REQUIRED_PREFIX,
  UpgradeRequiredPayloadSchema,
} from '@deepguide-ai/types'

function messageFromUnknown(error: unknown): string | null {
  if (typeof error === 'string') return error
  if (!error || typeof error !== 'object') return null

  const maybeMessage = (error as { message?: unknown }).message
  if (typeof maybeMessage === 'string') return maybeMessage

  const maybeShapeMessage = (error as { shape?: { message?: unknown } }).shape
    ?.message
  if (typeof maybeShapeMessage === 'string') return maybeShapeMessage

  const maybeDataMessage = (error as { data?: { message?: unknown } }).data
    ?.message
  if (typeof maybeDataMessage === 'string') return maybeDataMessage

  return null
}

export function parseUpgradeRequired(
  error: unknown
): UpgradeRequiredPayload | null {
  const message = messageFromUnknown(error)
  const prefixIndex = message?.indexOf(UPGRADE_REQUIRED_PREFIX) ?? -1
  if (prefixIndex === -1) return null

  try {
    const payload = JSON.parse(
      message.slice(prefixIndex + UPGRADE_REQUIRED_PREFIX.length)
    )
    return UpgradeRequiredPayloadSchema.parse(payload)
  } catch {
    return null
  }
}

export function upgradeMessageOrNull(error: unknown): string | null {
  return parseUpgradeRequired(error)?.message ?? null
}

export function upgradeTargetForPlan(currentPlan: Plan): Plan {
  switch (currentPlan) {
    case 'FREE':
      return 'STARTER'
    case 'STARTER':
    case 'TEAM':
      return 'PRO'
    default:
      return 'ENTERPRISE'
  }
}
